import * as React from "react";
import { injectIntl } from "react-intl";
import { IErrorMessage } from "../Models/FeedbackForm";

const ErrorMessageView: React.FC<IErrorMessage>  = ({intl, brandStyle, fieldName, focusHandler}) => {
    let hasError = false;
    let fieldDisplayName, errorMessage;

    switch (fieldName) {
        case "feedbackSubject":
          hasError = true;
          fieldDisplayName = intl.formatMessage({ id: "Subject_of_feedback" });
          errorMessage = intl.formatMessage({ id: "Please_select" }) + " " + intl.formatMessage({ id: "subject_of_feedback_lower" });
          break;
        case "comments":
          hasError = true;
          fieldDisplayName = intl.formatMessage({ id: "COMMENTS" });
          errorMessage = intl.formatMessage({ id: "Please_enter" }) + " " + intl.formatMessage({ id: "Comments_lower" });
          break;
        case "emailAdd":
          hasError = true;
          fieldDisplayName = intl.formatMessage({ id: "Email_address" });
          errorMessage = intl.formatMessage({ id: "Please_enter_your" }) + " " + intl.formatMessage({ id: "email_address_lower" });
          break;
        case "telephone":
          hasError = true;
          fieldDisplayName = intl.formatMessage({ id: "Telephone_number" });
          errorMessage = intl.formatMessage({ id: "Please_enter_your" }) + " " + intl.formatMessage({ id: "telephone_number_lower" });
          break;
        case "ipRelay":
          hasError = true;
          fieldDisplayName = intl.formatMessage({ id: "IP_relay_number" });
          errorMessage = intl.formatMessage({ id: "Please_enter_your" }) + " " + intl.formatMessage({ id: "IP_relay_number_lower" });
          break;
        case "ttyNumber":
          hasError = true;
          fieldDisplayName = intl.formatMessage({ id: "TTY_number" });
          errorMessage = intl.formatMessage({ id: "Please_enter_your" }) + " " + intl.formatMessage({ id: "TTY_number_lower" });
          break;
        case "videoRelayService":
          hasError = true;
          fieldDisplayName = intl.formatMessage({ id: "Video_relay_service_number" });
          errorMessage = intl.formatMessage({ id: "Please_enter_your" }) + " " + intl.formatMessage({ id: "Video_relay_service_number_lower" });
          break;
        case "alternateFormatDocuments":
          hasError = true;
          fieldDisplayName = intl.formatMessage({ id: "Select_alternate_format_document" });
          errorMessage = (brandStyle.toLowerCase() === "lucky" ? intl.formatMessage({ id: "Please_select" }) : intl.formatMessage({ id: "Please_select2" })) + " " + intl.formatMessage({ id: "alternate_format_document_lower" });
          break;
        case "requestAlternateFormatTypes":
          hasError = true;
          fieldDisplayName = intl.formatMessage({ id: "Choose_format" });
          errorMessage = intl.formatMessage({ id: "Please_select" }) + " " + intl.formatMessage({ id: "format_lower" });
          break;
        case "brailleFormatType":
        case "electronicFormatType":
        case "audioFormatType":
          hasError = true;
          fieldDisplayName = intl.formatMessage({ id: "Type_of_format" });
          errorMessage = intl.formatMessage({ id: "Please_select" }) + " " + intl.formatMessage({ id: "type_of_format_lower" });
          break;
        case "audioDeliveryType":
          hasError = true;
          fieldDisplayName = intl.formatMessage({ id: "Delivery_format" });
          errorMessage = intl.formatMessage({ id: "Please_select" }) + " " + intl.formatMessage({ id: "delivery_format_lower" });
          break;
        case "otherFormatType":
          hasError = true;
          fieldDisplayName = intl.formatMessage({ id: "Describe_the_other_formats" });
          errorMessage = intl.formatMessage({ id: "Please_enter" }) + " " + intl.formatMessage({ id: "description_of_the_other_formats" });
          break;
        case "RAF_fullName":
          hasError = true;
          fieldDisplayName = intl.formatMessage({ id: "Full_name" });
          errorMessage = intl.formatMessage({ id: "Please_enter_your" }) + " " + intl.formatMessage({ id: "full_name_lower" });
          break;
        case "RAF_email":
          hasError = true;
          fieldDisplayName = intl.formatMessage({ id: "Email_address" });
          errorMessage = intl.formatMessage({ id: "Please_enter_your" }) + " " + intl.formatMessage({ id: "email_address_lower" });
          break;
        case "RAF_telephone":
          hasError = true;
          fieldDisplayName = intl.formatMessage({ id: "Telephone_number" });
          errorMessage = intl.formatMessage({ id: "Please_enter_your" }) + " " + intl.formatMessage({ id: "telephone_number_lower" });
          break;
        case "RAF_streetAdd":
          hasError = true;
          fieldDisplayName = intl.formatMessage({ id: "Street_address" });
          errorMessage = intl.formatMessage({ id: "Please_enter_your" }) + " " + intl.formatMessage({ id: "street_address_lower" });
          break;
        case "RAF_city":
          hasError = true;
          fieldDisplayName = intl.formatMessage({ id: "City" });
          errorMessage = intl.formatMessage({ id: "Please_enter_your" }) + " " + intl.formatMessage({ id: "city_lower" });
          break;
        case "RAF_province":
          hasError = true;
          fieldDisplayName = intl.formatMessage({ id: "Province" });
          errorMessage = intl.formatMessage({ id: "Please_select" }) + " " + intl.formatMessage({ id: "province_lower" });
          break;
        case "RAF_country":
          hasError = true;
          fieldDisplayName = intl.formatMessage({ id: "Country" });
          errorMessage = intl.formatMessage({ id: "Please_select" }) + " " + intl.formatMessage({ id: "country_lower" });
          break;
        case "RAF_postalCode":
          hasError = true;
          fieldDisplayName = intl.formatMessage({ id: "Postal_code" });
          errorMessage = intl.formatMessage({ id: "Please_enter" }) + " " + intl.formatMessage({ id: "postal_code_lower" });
          break;
        default:
          break;
    }

    if (hasError) {
      return (
        <>
            <a href="javascript:void(0)" className="txtRed txtBold txtUnderline" onClick={() => { focusHandler(fieldName); return false; }}>{fieldDisplayName}</a>
            <span> - {errorMessage}</span>
        </>
      );
    }
    else {
        return <></>;
    }
};

export const ErrorMessage = injectIntl(ErrorMessageView);
